<div class="headlines" style="margin-bottom:50px">About</div>

<div class="headlines2" style="text-decoration:underline">How to Cite</div>
<div style="max-width:900px; margin:auto; font-size:medium; text-align: justify;">
    <textarea readonly disabled style="width: 100%" rows="4">{{document_text}}</textarea>
    <button (click)="myFunction()" class="button-link">Copy text</button>
</div>

<div class="headlines2" style="text-decoration:underline;">Disclaimer</div>
<div style="max-width:900px; margin:auto; font-size:medium; text-align: justify;">
    SeqCAT, does not use cookies or store any personal data about its visitors. We respect your privacy and are
    committed to providing a secure and transparent online experience.

    By accessing and using this website, you acknowledge and agree to the following:
    <ol style="margin-top: 10px;">
        <li style="margin-top: 10px;"><span style="font-weight: bold;">Use of Cookies:</span> We do not use any cookies on this website. Cookies are small text files that are placed on
            your device to collect and store information. Since we do not use cookies, we do not track your browsing
            behavior, preferences, or any other personal information through this mechanism.</li>
        <li style="margin-top: 10px;"><span style="font-weight: bold;">No Data Storage:</span> We do not store any personal data about you on our servers. This includes, but is not
            limited to, information such as your name, email address, or any other personally identifiable information.
            We prioritize the protection of your privacy and ensure that your visit to our website is secure and
            anonymous.</li>
    </ol>
</div>

<div class="headlines2" style="margin-top: 50px;text-decoration:underline">License</div>
<div style="max-width:900px; margin:auto; font-size:medium; text-align: justify;">
    SeqCAT operates under the Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0). By accessing and using this website, you acknowledge and agree to the terms of the Creative Commons License as outlined below:

    Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0):
    <ol style="margin-top: 10px;">
        <li style="margin-top: 10px;"><span style="font-weight: normal;">You are free to:</span><br>
            <span style="font-weight: bold;">Share:</span> Copy and redistribute the material in any medium or format.<br>
            <span style="font-weight: bold;">Adapt:</span> Remix, transform, and build upon the material for any purpose, even commercially.
        </li>
        <li style="margin-top: 10px;"><span style="font-weight: normal;">Under the following terms:</span><br>
            <span style="font-weight: bold;">Attribution:</span> You must give appropriate credit, provide a link to the license, and indicate if changes were made. You may do so in any reasonable manner, but not in any way that suggests the licensor endorses you or your use.<br>
            <span style="font-weight: bold;">ShareAlike:</span> If you remix, transform, or build upon the material, you must distribute your contributions under the same license as the original.
        </li>
        <li style="margin-top: 10px;"><span style="font-weight: normal;">No Additional Restrictions:</span> You may not apply legal terms or technological measures that legally restrict others from doing anything the license permits.</li>
    </ol>
    More information can be found at: <a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en">Creative Commons Attribution-ShareAlike 4.0 International License (CC BY-SA 4.0)</a>
    <div style="display:block;margin:10px auto;height:40px;width: 120px;"><a href="https://creativecommons.org/licenses/by-sa/4.0/deed.en" target="_blank" rel="noopener noreferrer"><img src="./assets/images/by-sa.svg"
        style="height:40px;width: 120px;" /></a></div>
</div>


<div class="headlines2" style="margin-top: 50px; text-decoration:underline">Contact</div>
<div class="card-container" style="margin-bottom: 100px;">
    <div class="card">
        <img class="head-icon" src="./assets/images/IcRoundAccountBox.svg" alt="">
        <div class="card-content">
            <div class="card-title">Kevin Kornrumpf</div>
            <div class="card-description">
                PhD Student<br>
                Department of Medical Bioinformatics<br>
                University Medical Center Göttingen (UMG)<br>
                <a href="https://bioinformatics.umg.eu/research/workgroups/knowledge-management/">Department of Medical
                    Bioinformatics - Knowledge Management</a>
            </div>
        </div>

    </div>
    <div class="card">
        <img class="head-icon" src="./assets/images/IcRoundAccountBox.svg" alt="">
        <div class="card-content">
            <div class="card-title">Dr. Jürgen Dönitz</div>
            <div class="card-description">
                Group Leader<br>
                Department of Medical Bioinformatics<br>
                University Medical Center Göttingen (UMG)</div>
            <a href="https://bioinformatics.umg.eu/research/workgroups/knowledge-management/">Department of Medical
                Bioinformatics - Knowledge Management</a>
        </div>
    </div>
</div>